<template>
  <div class="bgView" v-show="showSelf">
    <div class="alertBox">
      <header class="alertBoxHeader">提示</header>
      <div class="alertBoxBody">
       {{message}}
      </div>
      <footer class="alertBoxFooter">
        <div class="cancelBtn" v-if="showCancel" @click="onCancel" >{{cancelText}}</div>
        <div class="confirmBtn" @click="confirmBtnClicked" >{{confirmText}}</div>
      </footer>
    </div>
   
  </div>
  
</template>

<script>

export default {
  name: 'Main',
  data () {
    return {
      showSelf:false,
      showCancel:false,
      title:'提示',
      message:'',
      confirmText:'确定',
      cancelText:'取消'
    }
  },
  mounted() {
   window.$alertBox = this;
  },
  methods: {
    onCancel() {
      this.showSelf = false;
    },
    confirmBtnClicked() {
      this.showSelf = false;
      console.log(this);
      this.onConfirm();
    },
    onConfirm() {
      console.log("alertbox onconfirm");
    },
    alert(para) {
      this.showSelf = para.hasOwnProperty("show") ? para.show : true;
      this.title = para.title || "提示";
      this.message = para.message || "";
      this.type = para.type || "warning";
      // this.onOk = para.onOk || false;
      // this.onCancel = para.onCancel || false;
      this.highlight = para.highlight || (para.onCancel ? 0 : 1);
      this.confirmText = para.confirmText || "确定";
      this.cancelText = para.cancelText || "取消";
      this.showCancel = para.showCancel || false;
      this.onConfirm = para.onConfirm || this.onConfirm;

      this.$nextTick(() => {
        this.$el.focus();
      });
    }
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


.bgView {
  width:100%;
  height: 100%;
  top:0px;
  left:0;
  position: fixed;
  z-index: 999;
  background: #000000a0;
 display: flex;
  justify-content: center;
  align-items: center;
}

.alertBox {
  width:300px;
  height: auto;
  border-radius: 8px;
  background: white;
}
.alertBoxHeader {
  width:100%;
  height: 30px;
  position: relative;
  border-bottom: 1px solid black;
   display: flex;
  justify-content: center;
  align-items: center;
}

.alertBoxBody {
  width:calc(100% - 20px);
  height: 140px;
  padding:10px;
  display: block;
  text-align: left;
  font-size: 14px;
}


.alertBoxFooter {
   width:100%;
  height: 30px;
  position: relative;
  border-top: 1px solid black;
  line-height: 30px;
   display: flex;
  justify-content: center;
  align-items: center;
}
.cancelBtn {
  width:100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  cursor: pointer;
}
.confirmBtn {
  width:100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/AlertBox.vue